export const LABELS = {
  FILE_TYPE: "ファイル種別",
  FILE_NAME: "ファイル名",
  APPLICATION_DATE: "申請日時",
  FILE_CREATED_AT: "ファイル作成日時",
  APPLICATION_EMAIL: "申請者メールアドレス",
  RESULT_FILE: "結果ファイル"
};

// 一覧の1ページ当たりの件数
export const LIST_PAGE_SIZE = 20;

